module.exports = __webpack_public_path__ + "static/thumbnail_bookingcom_flat-f46b7c1ffce16439f05bdf5e46640208.jpg";